import styled from 'styled-components';

const DivHomePageAction = styled.div`
  position: fixed;
  display: flex;
  gap: 16px;
  bottom: 32px;
  right: 32px;
`;

export default DivHomePageAction;
